import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";


function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="documentDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="employmentStartDate" upload={upload} inExtWindow={inExtWindow}/>
            <table style={{fontSize: 12, whiteSpace:'nowrap'}} >

                <tbody>
                <tr>
                    <td>

                    </td>
                    <td className="text-end">
                        Current Year
                    </td>
                    <td className="text-end">
                        Last Year
                    </td>
                    <td className="text-end">
                        Year Before
                    </td>
                    <td className="text-end">
                        Year Before That
                    </td>
                    <td className="text-end ps-24">
                        Guaranteed
                    </td>
                </tr>
                <tr>

                    <td>
                        Gross basic
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="grossBasicThisYear" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="grossBasicYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="grossBasicYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="grossBasicYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">

                    </td>
                </tr>
                <tr>
                    <td>
                        Car allowance
                    </td>
                    <td></td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="carAllowanceYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="carAllowanceYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="carAllowanceYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">
                        <UploadDataPoint setMortgage={setMortgage} name="carAllowanceGuaranteed" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>

                </tr>
                <tr>
                    <td>
                        Shift allowance
                    </td>
                    <td></td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="shiftAllowanceYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="shiftAllowanceYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="shiftAllowanceYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">
                        <UploadDataPoint setMortgage={setMortgage} name="shiftAllowanceGuaranteed" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>

                </tr>
                <tr>
                    <td>
                        Other allowance
                    </td>
                    <td></td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="otherAllowanceYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="otherAllowanceYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="otherAllowanceYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">
                        <UploadDataPoint setMortgage={setMortgage} name="otherAllowanceGuaranteed" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>

                </tr>
                <tr>
                    <td>
                        Overtime
                    </td>
                    <td></td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="overtimeYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="overtimeYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="overtimeYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">
                        <UploadDataPoint setMortgage={setMortgage} name="overtimeGuaranteed" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>

                </tr>
                <tr>
                    <td>
                        Commission
                    </td>
                    <td></td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="commissionYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="commissionYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="commissionYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">
                        <UploadDataPoint setMortgage={setMortgage} name="commissionGuaranteed" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>

                </tr>
                <tr>
                    <td>
                        Bonus
                    </td>
                    <td></td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="bonusYearMostRecent" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="bonusYearBefore" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td>
                        <UploadDataPoint setMortgage={setMortgage} name="bonusYearBeforeThat" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>
                    <td className="ps-24">
                        <UploadDataPoint setMortgage={setMortgage} name="bonusGuaranteed" upload={upload} inExtWindow={inExtWindow} showLabel={false}/>
                    </td>

                </tr>
                </tbody>
            </table>


        </>
    );


}


export default DataForm;